import React, { useEffect } from "react";
import './RefundPolicySuccess.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
const RefundPolicySuccess = () => {


 
   useEffect(() => {
     AOS.init({
         duration: 1000,
         offset: 100,
         delay: 500,
         easing: 'ease-in-sine',
         anchorPlacement: 'top-bottom',
       once: false,  
     });
 
     const handleTabShown = () => {
         setTimeout(() => {
           AOS.refresh(); // Or use AOS.refreshHard() if content is dynamic
         }, 100);
       };
   
       const tabs = document.querySelectorAll('[data-bs-toggle="tab"]');
       tabs.forEach((tab) => {
         tab.addEventListener('shown.bs.tab', handleTabShown);
       });
   
       return () => {
         tabs.forEach((tab) => {
           tab.removeEventListener('shown.bs.tab', handleTabShown);
         });
       };
       
   }, []);
 
   return (
    <>
      {/* START refundPolicySuccessMain */}
      <section className="refundPolicySuccessMain" id="refundpolicy">
        <div className="container">
          <div className="swiper backgound_gradient">
            <div className="swiper-wrapper" aria-live="polite">
              <div className="swiper-slide gradient_slide" aria-label="1 / 9">
                <div sticky-image="0" className="rd_marron"></div>
              </div>
              <div className="swiper-slide gradient_slide" aria-label="2 / 9">
                <div sticky-image="1" className="rd_forest"></div>
              </div>
              <div className="swiper-slide gradient_slide" aria-label="3 / 9">
                <div sticky-image="2" className="rg_pink"></div>
              </div>
              <div className="swiper-slide gradient_slide" aria-label="4 / 9">
                <div sticky-image="3" className="rg_red"></div>
              </div>
              <div className="swiper-slide gradient_slide" aria-label="5 / 9">
                <div sticky-image="4" className="rg_red"></div>
              </div>
              <div className="swiper-slide gradient_slide" aria-label="6 / 9">
                <div sticky-image="5" className="rg_red"></div>
              </div>
              <div className="swiper-slide gradient_slide" aria-label="7 / 9">
                <div sticky-image="6" className="rg_red"></div>
              </div>
              <div className="swiper-slide gradient_slide" aria-label="8 / 9">
                <div sticky-image="7" className="rg_red"></div>
              </div>
              <div className="swiper-slide gradient_slide" aria-label="9 / 9">
                <div sticky-image="8" className="rg_red"></div>
              </div>
            </div>
          </div>

          <div className="refundPolicySuccessOuter">
            <div id="scroll-block" className="refundPolicySuccessLeft">
              <div scrolling-block="0" className="scrolling_item">
                <div className="refundPolicySuccessInner">
                  <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                  <h2><span>Refund policy</span> for your business plan.</h2>
                  <p>You’re in control of the refund process with technology that simplifies every step—tailor policies 
                    to fit your business, ensure transparency with automated updates, and manage refunds effortlessly.</p>
                </div>
              </div>

              <div scrolling-block="1" className="scrolling_item">
                <div className="refundPolicySuccessInner">
                    <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                    <h2><span>Refund Process</span> Step 1:</h2>
                    <h4>Verify booking details</h4>
                    <p>Confirm the correct booking by verifying trip details, vehicle information, and guest data.</p>
                </div>
              </div>

              <div scrolling-block="2" className="scrolling_item">
                <div className="refundPolicySuccessInner">
                      <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                      <h2><span>Refund Process</span> Step 2:</h2>
                      <h4>Select Reason</h4>
                      <p>Indicate the reason for issuing the refund by selecting the option that best applies.</p>
                  </div>
              </div>
              <div scrolling-block="3" className="scrolling_item">
                <div className="refundPolicySuccessInner">
                      <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                      <h2><span>Refund Process</span> Step 3:</h2>
                      <h4>Provide Amount</h4>
                      <p>Enter the refund amount you wish to issue for the booking, ensuring it reflects for any adjustments.</p>
                  </div>
              </div>
              <div scrolling-block="4" className="scrolling_item">
                <div className="refundPolicySuccessInner">
                      <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                      <h2><span>Refund Process</span> Step 4:</h2>
                      <h4>Process Refund</h4>
                      <p>Funds will be credited directly to your guest within 5-7 business days. Although refunds on rentid are free, Stripe does charge a processing fee.</p>
                  </div>
              </div>
              <div scrolling-block="5" className="scrolling_item">
                <div className="refundPolicySuccessInner" id='violations'>
                    <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/violations_icon.svg"/>
                    <h2><span style={{ color: '#FFFCC2' }}>Violations</span> during rental period</h2>
                    <p>Our recovery tools put you in control, providing everything you need to manage guest 
                    overages and usage issues with clarity and confidence. From extra mileage to 
                    unauthorized use, our system ensures fair, efficient cost recovery while safeguarding
                    your assets.</p>
                  </div>
              </div>
              <div scrolling-block="6" className="scrolling_item">
                <div className="refundPolicySuccessInner" id="tolls_and_tickets">
                      <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/tolls_icon.svg"/>
                      <h2><span style={{ color: '#BCF6C4' }}>Tolls & Tickets</span> Management</h2>
                      <p>Automate toll tracking, real-time billing, and violation processing across all agencies. 
                        Recover toll costs instantly, manage nationwide charges in one place, and eliminate manual 
                        ticket handling. Connect your toll pass account for automatic rebilling or enroll in 
                        our nationwide service to avoid admin fees, paper violations, and registration holds. 
                        Charges are added directly to the renter’s final invoice.</p>
                  </div>
              </div>



              <div scrolling-block="7" className="scrolling_item">
                <div className="refundPolicySuccessInner" id="insurance_claims">
                      <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/insurance_icon.svg"/>
                      <h2><span style={{ color: '#ECD0FE' }}>Insurance</span> claims management</h2>
                      <p>Your claims management office provides everything you need to handle insurance claims  Whether 
                      you’re filing a new claim, tracking progress, or reviewing past cases, we make it easy to stay 
                      informed and in control—all in one place.</p>
                  </div>
              </div>
              <div scrolling-block="8" className="scrolling_item">
                <div className="refundPolicySuccessInner" id="guest_behaviors">
                  <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/report_icon.svg"/>
                  <h2><span style={{ color: '#FFCAD3' }}>Report</span> guest behaviors</h2>
                  <p>Your feedback is essential to maintaining a safe and positive rental experience. 
                  Our reporting tools empower you to document and address inappropriate or unsafe 
                  guest behaviors quickly and effectively, helping us ensure a secure environment 
                  for all users.</p>
                  </div>
              </div>
            </div>

            <div className="refundPolicySuccessRight">
              <div className="mobile_bg">
                <div className="background_grain_black">
                  <div className="grains_image"></div>
                </div>
              </div>
              <div className="swiper scrolling-images">
                <div className="swiper-wrapper">
                  <div className="swiper-slide scrolling_image_slide" role="group" aria-label="1 / 9">
                    <div className="changing_img changing_img_new">
                      <img className="contain_image" alt="Rent Success" src="/img/rentsuccess/refundPolicySuccess_1.webp" />
                    </div>
                  </div>
                  <div className="swiper-slide scrolling_image_slide" role="group" aria-label="2 / 9">
                    <div className="changing_img changing_img_new">
                      <img className="contain_image" alt="Rent Success" src="/img/rentsuccess/refundPolicySuccess_2.webp" />
                    </div>
                  </div>
                  <div className="swiper-slide scrolling_image_slide" role="group" aria-label="3 / 9">
                    <div className="changing_img changing_img_new">
                      <img className="contain_image" alt="Rent Success" src="/img/rentsuccess/refundPolicySuccess_3.webp" />
                    </div>
                  </div>
                  <div className="swiper-slide scrolling_image_slide" role="group" aria-label="4 / 9">
                    <div className="changing_img changing_img_new">
                      <img className="contain_image" alt="contain" src="/img/rentsuccess/refundPolicySuccess_4.webp" />
                    </div>
                  </div>
                  <div className="swiper-slide scrolling_image_slide" role="group" aria-label="5 / 9">
                    <div className="changing_img changing_img_new ">
                        <img className="contain_image" alt="contain" src="/img/rentsuccess/refundPolicySuccess_4.webp" />
                        <img className="refundPolicySuccess_51" data-aos="fade-up" data-aos-delay="200" src="/img/rentsuccess/refundPolicySuccess_51.webp" alt="refund" />
                        <img className="refundPolicySuccess_52" data-aos="fade-up" data-aos-delay="300" src="/img/rentsuccess/refundPolicySuccess_52.webp" alt="refund" />
                    </div>
                  </div>

                  <div className="swiper-slide scrolling_image_slide" role="group" aria-label="6 / 9">
                    <div className="changing_img changing_img_new refundPolicySecRight">
                        <img className="contain_image" data-aos="zoom-in" data-aos-delay="200" src="/img/rentsuccess/refundPolicySec_1.webp" alt="rent id"/>
                    </div>
                  </div>

                  <div className="swiper-slide scrolling_image_slide" role="group" aria-label="7 / 9">
                    <div className="changing_img changing_img_new refundPolicySecRight">
                        <img className="refundTolls_1" src="/img/rentsuccess/refundTolls_1.webp" alt="rent id"/>
                        <img className="refundTolls_2" data-aos="zoom-in" data-aos-delay="100" src="/img/rentsuccess/refundTolls_2.webp" alt="rent id"/>
                        <img className="refundTolls_3" data-aos="fade-up" data-aos-delay="100" src="/img/rentsuccess/refundTolls_3.webp"alt="rent id"/>
  
                        <div className="for_tabletrefund">
                          <img className="img-fluid" src="/img/rentsuccess/refundTolls_single.webp" alt="rent id"/>
                        </div>
                      </div>
                  </div>

                  <div className="swiper-slide scrolling_image_slide" role="group" aria-label="8 / 9">
                    <div className="changing_img changing_img_new refundPolicySecRight">
                        <img className="refundPolicySec_21" width="486" src="/img/rentsuccess/refundPolicySec_21.webp" alt="rent id"/>
                        <img className="refundPolicySec_22" width="242" data-aos="zoom-in" data-aos-delay="200" src="/img/rentsuccess/refundPolicySec_22.png" alt="rent id"/>
                    </div>
                  </div>
                  <div className="swiper-slide scrolling_image_slide " role="group" aria-label="9 / 9" id="customwidth_9">
                    <div className="changing_img changing_img_new refundPolicySecRight">
                        <img className="refundPolicySec_30" width="309px" src="/img/rentsuccess/refundPolicySec_30.png" alt="rent id"/>
                        <img className="refundPolicySec_31" width="309px" src="/img/rentsuccess/refundPolicySec_31.webp" alt="rent id"/>
                        <img className="refundPolicySec_33" width='270px' data-aos="fade-down" data-aos-delay="400" src="/img/rentsuccess/refundPolicySec_33.webp"alt="rent id"/>
                        <img className="refundPolicySec_34" width="270px" data-aos="fade-up" data-aos-delay="600" src="/img/rentsuccess/refundPolicySec_34.webp" alt="rent id"/>
                        <div className="for_tabletrefund">
                          <img className="img-fluid" src="/img/rentsuccess/mobile_refundPolicySec_3.webp" alt="rent id"/>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
      {/* END refundPolicySuccessMain */}

      {/* START refundPolicyMobileMain */}
      <section className="refundPolicyMobileMain">
        <div className="container"> 
          {/* 1 */}
          <div className="refundPolicyMobileInner">
              <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileLeft">
                        <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                        <h2><span>Refund policy</span> for your business plan.</h2>
                        <p>You’re in control of the refund process with technology that simplifies every step—tailor policies 
                        to fit your business, ensure transparency with automated updates, and manage refunds effortlessly.</p>
                      </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileRight">
                          <img className="img-fluid" src="/img/rentsuccess/refundPolicySuccess_1.webp" alt="rent id"/>
                      </div>
                  </div>
              </div>
          </div>

          {/* 2 */}
          <div className="refundPolicyMobileInner">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                    <div className="refundPolicyMobileLeft">
                      <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                      <h2><span>Refund Process</span> Step 1:</h2>
                      <h4>Verify booking details</h4>
                      <p>Confirm the correct booking by verifying trip details, vehicle information, and guest data.</p>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="refundPolicyMobileRight">
                      <img className="img-fluid" src="/img/rentsuccess/refundPolicySuccess_2.webp" alt="Refund Process"/>
                    </div>
                </div>
            </div>
          </div>

          {/* 3 */}
          <div className="refundPolicyMobileInner">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                    <div className="refundPolicyMobileLeft">
                    <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                    <h2><span>Refund Process</span> Step 2:</h2>
                    <h4>Select Reason</h4>
                    <p>Indicate the reason for issuing the refund by selecting the option that best applies.</p>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="refundPolicyMobileRight">
                      <img className="img-fluid" src="/img/rentsuccess/refundPolicySuccess_3.webp" alt="Select Reason"/>
                    </div>
                </div>
            </div>
          </div>

          {/* 4 */}
          <div className="refundPolicyMobileInner">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                    <div className="refundPolicyMobileLeft">
                        <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                        <h2><span>Refund Process</span> Step 3:</h2>
                        <h4>Provide Amount</h4>
                        <p>Enter the refund amount you wish to issue for the booking, ensuring it reflects for any adjustments.</p>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="refundPolicyMobileRight">
                    <img className="img-fluid" src="/img/rentsuccess/refundPolicySuccess_4.webp" alt="Provide Amount"/>
                    </div>
                </div>
            </div>
          </div>

          {/* 5 */}
          <div className="refundPolicyMobileInner">
              <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileLeft">
                          <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/refundPolicyicon_1.svg" />
                          <h2><span>Refund Process</span> Step 4:</h2>
                          <h4>Process Refund</h4>
                          <p>Funds will be credited directly to your guest within 5-7 business days. Although refunds on rentid are free, Stripe does charge a processing fee.</p>
                      </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileRight">
                        <img className="img-fluid" src="/img/rentsuccess/mobileRefundPolicySuccess_5.webp" alt="Process Refund"/>
                      </div>
                  </div>
              </div>
          </div>

          {/* 6 */}
          <div className="refundPolicyMobileInner">
              <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileLeft">
                        <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/violations_icon.svg"/>
                        <h2><span style={{ color: '#FFFCC2' }}>Violations</span> during rental period</h2>
                        <p>Our recovery tools put you in control, providing everything you need to manage guest 
                        overages and usage issues with clarity and confidence. From extra mileage to 
                        unauthorized use, our system ensures fair, efficient cost recovery while safeguarding
                        your assets.</p>
                      </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileRight">
                          <img className="img-fluid" src="/img/rentsuccess/refundPolicySec_1.webp" alt="Violations"/>
                      </div>
                  </div>
              </div>
          </div>

          {/* 7 */}
          <div className="refundPolicyMobileInner">
              <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileLeft">
                          <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/tolls_icon.svg"/>
                          <h2><span style={{ color: '#BCF6C4' }}>Tolls & Tickets</span> Management</h2>
                          <p>Automate toll tracking, real-time billing, and violation processing across all agencies. 
                          Recover toll costs instantly, manage nationwide charges in one place, and eliminate manual 
                          ticket handling. Connect your toll pass account for automatic rebilling or enroll in 
                          our nationwide service to avoid admin fees, paper violations, and registration holds. 
                          Charges are added directly to the renter’s final invoice.</p>
                      </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileRight">
                        <img className="img-fluid" src="/img/rentsuccess/refundTolls_single.webp" alt="Tolls & Tickets"/>
                      </div>
                  </div>
              </div>
          </div>

          {/* 8 */}
          <div className="refundPolicyMobileInner">
              <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileLeft">
                          <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/insurance_icon.svg"/>
                          <h2><span style={{ color: '#ECD0FE' }}>Insurance</span> claims management</h2>
                          <p>Your claims management office provides everything you need to handle insurance claims  Whether 
                          you’re filing a new claim, tracking progress, or reviewing past cases, we make it easy to stay 
                          informed and in control—all in one place.</p>
                      </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileRight">
                        <img className="img-fluid" src="/img/rentsuccess/mobile_refundPolicySec_2.png" alt="Insurance claims management"/>
                      </div>
                  </div>
              </div>
          </div>

          {/* 9 */}
          <div className="refundPolicyMobileInner">
              <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileLeft">
                        <img width="56px" height="56px" alt="icon" src="/img/rentsuccess/report_icon.svg"/>
                        <h2><span style={{ color: '#FFCAD3' }}>Report</span> guest behaviors</h2>
                        <p>Your feedback is essential to maintaining a safe and positive rental experience. 
                        Our reporting tools empower you to document and address inappropriate or unsafe 
                        guest behaviors quickly and effectively, helping us ensure a secure environment 
                        for all users.</p>
                      </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                      <div className="refundPolicyMobileRight">
                          <img className="img-fluid" src="/img/rentsuccess/mobile_refundPolicySec_3.webp" alt="Report guest behaviors"/>
                      </div>
                  </div>
              </div>
          </div>
                
        </div>
      </section>
      {/* END refundPolicyMobileMain */}
 
    </>
  );
};

export default RefundPolicySuccess;
